import React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';


class Notify extends React.Component {
    constructor(props) {

        super(props);
        this.getListOfIds = this.getListOfIds.bind(this);
        this.getRow = this.getRow.bind(this);
        this.componentName = "[Notify.jsx] ";
    }


    getListOfIds() {
        //return Object.keys(this.props.listOfNotify);

        let temp = new Array();

        for (let key of this.props.listOfNotify.keys()) {
            console.log(key);
            temp.push(key);
        }

        return temp;
    }
    getRow(key) {
        //console.log('[Notify] itemId: ' + key);
        let item = this.props.listOfNotify.get(key);
        //let item = value;


        //var myClass = "alert alert-dismissible fade in";
        var myClass = "alert fade show";
        myClass = myClass + " alert-" + item.messageType.toLowerCase();



        return <div key={item.messageId} className={myClass} role="alert">
            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => this.props.closeNotify(item.messageId)}>
                <span aria-hidden="true">&times;</span>
            </button>

            {item.message}

        </div>
    }
    render() {
        console.log(this.componentName + "render");
        if (this.props.listOfNotify === undefined || this.props.listOfNotify === null) {
            return null;
        }
        // console.log("listOfNotify.size: " + this.props.listOfNotify.size);
        //console.log("getListOfIds().length: " + this.getListOfIds().length);
        let elements = null;
        elements = this.getListOfIds().map(this.getRow);
        //elements = Object.keys (this.props.listOfNotify).map(this.getRow);

        //elements = this.props.listOfNotify.keys.map(this.getRow);
        //elements = this.props.listOfNotify.entries.map(this.getRow);

        //elements = this.props.listOfNotify.forEach(this.getRow);

        //console.log("listOfNotify.size: " + this.props.listOfNotify.size);
        return (
            <div>
                {elements}
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        listOfNotify: state.app.listOfNotify
    };
}

function mapDispatchToProps(dispatch) {
    return {
        closeNotify: function close(index) {
            return dispatch(AppActions.deleteNotify(index));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notify);